import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import HttpClient from '../../../api/api';
import {REmployees} from '../../roles/types';
import {getSessionCache, setSessionCache} from '../../../utils/session-cache';


const initialState: REmployees[] = []
const EMPLOYEES_CACHE_KEY = 'cache:employees:all';
const EMPLOYEES_CACHE_TTL_MS = 1000 * 60 * 15;

export const getAllEmployees = createAsyncThunk(
    'employees/filter',
    async () => {
        const cached = getSessionCache<REmployees[]>(EMPLOYEES_CACHE_KEY);
        if (cached && cached.length > 0) {
            return cached;
        }

        const response = await HttpClient.employeeApi.getAllEmployees<REmployees[]>();
        setSessionCache(EMPLOYEES_CACHE_KEY, response.data, EMPLOYEES_CACHE_TTL_MS);
        return response.data
    }
)

const typeSplice = createSlice({
    name: 'rEmployees',
    initialState,
    reducers: {
        clear: (state) => {
            return initialState
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getAllEmployees.fulfilled, (state, action) => {
            return [...action.payload];
        })
    }
})

export const { clear } = typeSplice.actions

export default typeSplice.reducer;
